<template>
  <TreeRender
    v-bind="$props"
    :nodes="nodesFiltered"
  >
    <template #default="{ node: nodeChild, isExpanded: isExpandedChild }">
      <slot
        :node="nodeChild"
        :is-expanded="isExpandedChild"
      />
    </template>
  </TreeRender>
</template>

<script>
import TreeRender from './TreeRender.vue';

export default {
  name: 'Tree',
  components: {
    TreeRender,
  },
  props: {
    childrenKey: {
      type: String,
      default: 'children',
    },
    labelKey: {
      type: String,
      default: 'label',
    },
    nodeKey: {
      type: String,
      required: true,
    },
    filter: {
      type: String,
      default: '',
    },
    nodes: {
      type: Array,
      default: () => [],
    },
    divider: {
      type: Boolean,
      default: false,
    },
    hideExpander: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nodesFiltered: [],
    };
  },
  watch: {
    filter(filter) {
      this.resetNodesData(this.nodes, filter);
    },
    nodes(nodes) {
      this.resetNodesData(nodes, this.filter);
    },
  },
  created() {
    this.resetNodesData(this.nodes, this.filter);
  },
  methods: {
    resetNodesData(nodes, filter) {
      if (filter.trim()) this.nodesFiltered = this.filterNodesData(nodes, filter);
      else this.nodesFiltered = [...nodes];
    },
    filterNodesData(nodes, filter) {
      return nodes.reduce((acc, current) => {
        let node = { ...current };
        if (current?.last_node === true) {
          node = current.parent;
          return acc;
        }
        const filterLower = filter.toLowerCase().replace(' ', '');
        const labelLower = node[this.labelKey].toLowerCase().replace(' ', '');
        let isMatchChildren = false;
        if (node[this.childrenKey] && node[this.childrenKey].length > 0) {
          const filtered = this.filterNodesData(node[this.childrenKey], filter);
          node[this.childrenKey] = [...filtered];
          isMatchChildren = filtered.length > 0;
        }

        const isMatchNode = labelLower.includes(filterLower);
        return (isMatchChildren || isMatchNode) ? [...acc, node] : [...acc];
      }, []);
    },
  },
};
</script>
